export default "__VITE_ASSET__l4KXut5q__"